/*
 * Copyright (c) 2022 Robert J Whelton. All rights reserved.
 */
import BLAKE2s from "blake2s-js"

function hash(string) {
  const h = new BLAKE2s(32)
  h.update(new TextEncoder().encode(string))
  return h.hexDigest()
}

export const isBrowser = () => typeof window !== "undefined"

export const getUser = () =>
  isBrowser() && localStorage.getItem("gatsbyUser")
    ? JSON.parse(localStorage.getItem("gatsbyUser"))
    : {}

const setUser = user => localStorage.setItem("gatsbyUser", JSON.stringify(user))

export const handleLogin = ({ username, password}) => {
  if (
    hash(username) === '0421e5c4d3f7e8dc5c392da23715ad2c851114aa3bb603267cb5d7c10336961a'
    && hash(password) === '46e3e1a40b78390025bc346f5904ba4ae7c67721b18067c2896846dd0bbdcc46'
  ) {
    setUser({
      username: `Tim`,
      name: `Tim the Enchanter`,
      role: 'The Dungeon Master'
    })
    return true
  }

  return false
}

export const isLoggedIn = () => {
  const user = getUser()

  return !!user.username
}

export const logout = callback => {
  setUser({})
  callback()
}
